
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>

 <v-row  justify="center">
   <v-col  cols="12" lg="12" md="12" sm="12">
   </v-col>
 </v-row>
  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import moment from "moment-timezone";
import Cabecerabaja from "@/components/general/cabecerabaja";

  export default {
    name: 'carro',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        tag: '',
        acto:{} ,
        top:true,
        entradas:[],
        entradaseve:[],
        entradaevento:{},
        right:true,
        direction:'top',
        center: { lat: 45.508, lng: -73.587 },
        foto:'',
        tipocompra:'',
        organizador:'',
        horaInicio:'',
        horaFinal:'',
        conectado:false
          }
    },
    mounted(){
      this.tag =  this.$route.params.tag
      this.traeActo()
      if(this.usuario.id>0){
        this.conectado = true

      }else{
        this.conectado = false
      }
    },
    watch:{
      '$store.state.usuario': function (){
        this.conectado = true
      }
    },
    methods: {
      formatDatee(value) {
        return moment(value).locale('es-pe').format("DD MMMM YYYY")
      },

    },
computed: {
  // map `this.user` to `this.$store.getters.user`
...mapGetters({
    usuario: "usuario",
    evento: "evento"
  })
}
  }
</script>
